export const documentStatuses = {
  draft: "draft",
  waitingForAdvisor: "waiting-for-advisor",
  waitingForSignature: "waiting-for-signature",
  waitingForRegistration: "waiting-for-registration",
  waitingForConfirmation: "waiting-for-confirmation",
  waitingForTestavivaRegistration: "waiting-for-testaviva-registration",
  waitingForMeeting: "waiting-for-meeting",
  waitingForPayment: "waiting-for-payment",
  updateRequired: "update-required",
  updateRecommended: "update-recommended",
  signed: "signed",
} as const;
